import PropTypes from "prop-types"

function P2Alert({withCTA = false, variant = "success", title = "Insert title", text, linkText = "Action", link, onClick, style}) {
  let iconElement

  if (variant === "success") {
    iconElement = <span className="bi bi-check-circle polymer-alert__icon polymer-alert__icon-success" />;
  } else if (variant === "warning") {
    iconElement = <span className="bi bi-exclamation-triangle polymer-alert__icon polymer-alert__icon-warning" />
  } else {
    iconElement = <span className="bi bi-exclamation-circle polymer-alert__icon polymer-alert__icon-danger" />
  }
  
  if (!withCTA) {
    return (
      <div className={`polymer-alert__container polymer-alert__container-${variant}`} style={style}>
        {iconElement}
        <span className={`polymer-alert__text-${variant}`}>
          {text}
        </span>
      </div>
    )
  } else {
    return (
      <div className={`polymer-alert__container-cta polymer-alert__container-cta-${variant}`}>
        {iconElement}
        <span className={`polymer-alert__title polymer-alert__title-${variant}`}>
          {title}
        </span>
        <a className="polymer-alert__link" href={link} onClick={onClick}>
          {`${linkText} >`}
        </a>
        <span className="polymer-alert__text-cta">
          {text}
        </span>
      </div>
    )
  }
}

P2Alert.propTypes = {
  withCTA: PropTypes.bool,
  variant: PropTypes.oneOf(["success", "warning", "danger"]),
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  linkText: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
};

P2Alert.defaultProps = {
  withCTA: false,
  variant: "success",
  title: "Notification Title",
  linkText: "Action",
}

export default P2Alert